import React from 'react';
import { ShortCardVariants } from 'Shorts/constants';
import { ChatUIEnhancementContentCard } from 'Assistant/__generated__/client.schemas';
import mapContentCardToTool from '../../../utils/mapContentCardToTool';
import { ContentCardsRow, ContentCardWrapper } from '../styles';
import { ContentCard } from '.';

type ContentCardsGroupProps = {
  group: { kind: 'content_card'; value: ChatUIEnhancementContentCard }[];
  groupStartKey: number | string;
};

const ContentCardsGroup = ({
  group,
  groupStartKey,
}: ContentCardsGroupProps) => (
  <ContentCardsRow key={`content-row-${groupStartKey}`}>
    {group.map((c, idx) => {
      const card = c.value;
      const tool = mapContentCardToTool(card);

      return (
        <ContentCardWrapper
          key={`${groupStartKey}-${idx}`}
          data-testid="assistant-content-card"
        >
          <ContentCard
            tool={tool}
            source="assistant-content-card"
            showDescription={true}
            showCategory={true}
            assetToken={card?.asset_token ?? null}
            variant={ShortCardVariants.VERTICAL}
          />
        </ContentCardWrapper>
      );
    })}
  </ContentCardsRow>
);

export default ContentCardsGroup;
